module.exports = __webpack_public_path__ + "img/bandaid-pink.5f53951b.svg";